export default __webpack_public_path__ + "static/media/mode-551.466635b3.svg";